import BigHeaderInfo from './components/BigHeaderInfo';
import ListWithSubheaders from './components/ListWithSubheaders';
import RecentList from './components/RecentList';
import RecentListMultipleRows from './components/RecentListMultipleRows';
import SpecificList from './components/SpecificList';
import SpecificListMultipleRows from './components/SpecificListMultipleRows';
import SpecificListNoDate from './components/SpecificListNoDate';

import type { IBigHeaderInfo } from './components/BigHeaderInfo';
import type { IListWithSubheaders } from './components/ListWithSubheaders';
import type { IRecentList } from './components/RecentList';
import type { IRecentListMultipleRows } from './components/RecentListMultipleRows';
import type { ISpecificList } from './components/SpecificList';
import type { ISpecificListMultipleRows } from './components/SpecificListMultipleRows';
import type { ISpecificListNoDate } from './components/SpecificListNoDate';

/**
 * TileContentMaker
 * Creates a component with specific props based on type.
 * Use _MultipleRows types when more specs require the title/value to be in some custom style
 */
const TileContentMaker = ({ ...props }: TTileContent) => {
  const type = props.type;
  switch (type) {
    case 'bigHeaderInfo':
      return <BigHeaderInfo {...props} />;
    case 'recentList':
      return <RecentList {...props} />;
    case 'specificList':
      return <SpecificList {...props} />;
    case 'listWithSubheaders':
      return <ListWithSubheaders {...props} />;
    case 'recentListMultipleRows':
      return <RecentListMultipleRows {...props} />;
    case 'specificListMultipleRows':
      return <SpecificListMultipleRows {...props} />;
    case 'specificListNoDate':
      return <SpecificListNoDate {...props} />;
    default:
      return null;
  }
};

type TTile =
  | 'bigHeaderInfo'
  | 'recentList'
  | 'specificList'
  | 'listWithSubheaders'
  | 'recentListMultipleRows'
  | 'specificListMultipleRows'
  | 'specificListNoDate';
type TTileContent = { type: TTile } & (
  | IBigHeaderInfo
  | IRecentList
  | ISpecificList
  | IListWithSubheaders
  | IRecentListMultipleRows
  | ISpecificListMultipleRows
  | ISpecificListNoDate
);

export default TileContentMaker;
